import classNames from 'classnames'
import type { ContentTeaserGroupProps } from './types'

export const ContentTeaserGroup = ({
  children,
  className,
  ...props
}: ContentTeaserGroupProps) => {
  return (
    <div className={classNames('content-teaser-group', className)} {...props}>
      {children}
    </div>
  )
}
